import { StringUtil } from "@mcleod/core";
import {
    ChangeEvent, DataSourceExecutionEvent, DataSourceMode, LookupModelSearchEvent,
    LookupModelSelectionEvent
} from "@mcleod/components";
import { AutogenLayoutRecurringAvailableTractor } from "./autogen/AutogenLayoutRecurringAvailableTractor";



export class RecurringAvailableTractor extends AutogenLayoutRecurringAvailableTractor {

    private _contactFilter = null;

    textboxCarrierIdOnChange(event: ChangeEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH
            && StringUtil.isEmptyString(event.newValue)) {
            this.setContact(null, null, null, null);
            this.removeContactSearchListenerIfNeeded();
            this.toggleContacts(false);
        }
    }

    private toggleContacts(value: boolean){
        this.textboxContactName.enabled = value;
        this.textboxContactPhone.enabled = value;
        this.textboxContactEmail.enabled = value;
        this.textboxContactFax.enabled = value;
    }

    private initializeContactFilter(carrierId: string) {
        this.removeContactSearchListenerIfNeeded();
        this._contactFilter = (event: LookupModelSearchEvent) => {
            event.filter.is_active = 'Y';
            event.filter.parent_row_type = 'P';
            event.filter.parent_row_id = carrierId;
        };
        this.textboxContactName.addBeforeLookupModelSearchListener(this._contactFilter);
    }

    private removeContactSearchListenerIfNeeded() {
        if (this._contactFilter) {
            this.textboxContactName.removeBeforeLookupModelSearchListener(this._contactFilter);
        }
    }

    textboxContactOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (this.mainDataSource.mode !== DataSourceMode.SEARCH && event.hasSelection()) {
            const contact = event.selection;
            this.setContact(
                contact.getString('name', null),
                contact.getString('phone', null),
                contact.getString('email', null),
                contact.getString('fax', null)
            );
        }
    }

    //When we select a carrier, default the Contacts
        async textboxCarrierIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
            if (this.mainDataSource.mode !== DataSourceMode.SEARCH
                && event.hasSelection()
            ) {
                const carrier = event.selection;  
                this.initializeContactFilter(carrier.getString('id', null));
    
    
                this.setContact(
                    carrier.getString('contact.name', null),
                    carrier.getString('contact.phone', null),
                    carrier.getString('contact.email', null),
                    carrier.getString('contact.fax', null)
                );
                this.toggleContacts(true);
                this.mainDataSource.displayDataInBoundComponents();
            }
        }

    sourceRecurringAvailableTractorAfterExecution(event: DataSourceExecutionEvent) {
        const availTractor = event.data;
        if (!availTractor.isNull('carrier_id')) {
            this.toggleContacts(true);
            this.initializeContactFilter(availTractor.getString('carrier_id'));
        }
        if (!availTractor.isNull('contact_name')) {
            this.activeRow.setLookupModelData('contact_name', {'name': availTractor.getString('contact_name')});
        }
    }

    private setContact(name: string, phone: string, email: string, fax: string) {
        this.activeRow.set({
            'contact_name': name,
            'contact_phone': phone,
            'contact_email': email,
            'contact_fax': fax
        });
        if (name == null) {
            this.activeRow.setLookupModelData('contact_name', null);
            this.textboxContactName.displayData(this.activeRow, null, 0);
        } else {
            this.activeRow.setLookupModelData('contact_name', {'name': name});
        }
    }

    trailerTypeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.applies_to = 'L';
    }
}